module.exports = __webpack_public_path__ + "img/LLPRO_CEFR_banner_man.14bd28eb.png";